import { render } from "./CalendarRangeClearIcon.vue?vue&type=template&id=37238e38"
import script from "./CalendarRangeClearIcon.vue?vue&type=script&lang=js"
export * from "./CalendarRangeClearIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__